import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC } from 'react';
import { FeatureBannerProps } from './FeatureBanner.type';
import { styles } from './FeatureBanner.style';
import { IS_WEB } from '../../../../../constants/platform';

const FeatureBanner: FC<FeatureBannerProps> = ({
  bannerPath,
  name,
  onPress,
  isFullSizeDesktop = false,
}) => {
  return (
    <TouchableOpacity
      style={[
        styles.wrapper,
        isFullSizeDesktop
          ? { aspectRatio: 21 / 7 }
          : { aspectRatio: 7 / 5 },
      ]}
      onPress={onPress}
    >
      <Image style={[
        styles.image,
        !IS_WEB && {
          width: 'auto',
          height: 270,
        }
      ]} source={{ uri: bannerPath }} />
      <View style={styles.contentWrapper}>
        <Text style={styles.contentName}>{name}</Text>
        <TouchableOpacity
          style={styles.contentBtnWrapper}
          activeOpacity={0.9}
          onPress={onPress}
        >
          <Text style={styles.contentBtnText}>Show now </Text>
          <Image
            style={styles.arrow}
            source={require('../../../../../assets/right-arrow.png')}
          />
        </TouchableOpacity>
      </View>
    </TouchableOpacity>
  );
};

export default FeatureBanner;
